import Style from './style'

import Pagenation from 'widget/Pagenation'

import useGetAccountStoreTicketList from 'entity/account/useGetAccountStoreTicketList'
import useGetAccountStoreTicketRecord from 'entity/account/useGetAccountStoreTicketRecord'

import TStyle from 'shared/style/tableStyle'
import timestampCalculator from 'shared/lib/timestampCalculator'
import {convertRecordTypeAsName} from 'shared/constant/lookup/recordType'
import TableLoading from 'shared/ui/TableLoading'

const StoreTicket = () => {
	const [ticketList, isLoading] = useGetAccountStoreTicketList()
	const [ticketRecord, recordLoading] = useGetAccountStoreTicketRecord()

	const sizeList = ['short', 'longlonglong', 'expand', 'longlonglong']
	const tableHeadList = ['IDX', '프랜차이즈', '매장 이용권 이름', '개수']

	const recordSizeList = [
		'short',
		'longlonglong',
		'long',
		'expand',
		'medium',
		'short',
		'long',
	]
	const recordTableHeadList = [
		'IDX',
		'프랜차이즈',
		'매장',
		'대회',
		'분류',
		'개수',
		'기록 날짜',
	]

	return (
		<Style.Wrapper>
			<Style.Area>
				<h2>보유</h2>

				<TableLoading isLoading={isLoading}>
					<TStyle.TableDiv>
						<TStyle.TableInner>
							<TStyle.TableRow $title>
								{tableHeadList.map((elem, index) => (
									<TStyle.Data key={index} $title $size={sizeList[index]}>
										{elem}
									</TStyle.Data>
								))}
							</TStyle.TableRow>
							{ticketList?.data?.store_ticket_list?.map((elem, index) => (
								<TStyle.TableRow key={index} $odd={index % 2 === 1}>
									<TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
									<TStyle.Data $size={sizeList[1]}>
										{elem?.franchise_name}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[2]}>
										{elem?.ticket_name}
									</TStyle.Data>
									<TStyle.Data $size={sizeList[3]}>
										<TStyle.Count>
											<p>총합: {elem?.ticket_number}</p>
											{elem?.ticket_detail?.length ? <hr /> : <></>}
											{elem?.ticket_detail?.map((detail) => (
												<p>
													<span>{detail.name}: </span>
													<span>{detail.number}</span>
												</p>
											))}
										</TStyle.Count>
									</TStyle.Data>
								</TStyle.TableRow>
							))}
						</TStyle.TableInner>
					</TStyle.TableDiv>
				</TableLoading>
			</Style.Area>

			<Style.Area $expand>
				<h2>사용 기록</h2>

				<TableLoading isLoading={recordLoading}>
					<TStyle.TableDiv>
						<TStyle.TableInner>
							<TStyle.TableRow $title>
								{recordTableHeadList.map((elem, index) => (
									<TStyle.Data key={index} $title $size={recordSizeList[index]}>
										{elem}
									</TStyle.Data>
								))}
							</TStyle.TableRow>
							{ticketRecord?.data?.store_ticket_record?.map((elem, index) => (
								<TStyle.TableRow key={index} $odd={index % 2 === 1}>
									<TStyle.Data $size={recordSizeList[0]}>
										{elem?.idx}
									</TStyle.Data>
									<TStyle.Data $size={recordSizeList[1]}>
										{elem?.franchise_name}
									</TStyle.Data>
									<TStyle.Data $size={recordSizeList[2]}>
										{elem?.store_name}
									</TStyle.Data>
									<TStyle.Data $size={recordSizeList[3]}>
										{elem?.event_name || '-'}
									</TStyle.Data>
									<TStyle.Data $size={recordSizeList[4]}>
										{convertRecordTypeAsName[elem?.ticket_record_type_flag]}
									</TStyle.Data>
									<TStyle.Data $size={recordSizeList[5]}>
										{elem?.number}
									</TStyle.Data>
									<TStyle.Data $size={recordSizeList[6]}>
										{timestampCalculator(elem?.created_at)}
									</TStyle.Data>
								</TStyle.TableRow>
							))}
						</TStyle.TableInner>
					</TStyle.TableDiv>
				</TableLoading>

				<Pagenation maxPage={1} />
			</Style.Area>
		</Style.Wrapper>
	)
}

export default StoreTicket
